import { render, staticRenderFns } from "./add.vue?vue&type=template&id=4b980ace&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=4b980ace&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b980ace",
  null
  
)

export default component.exports